import { render, staticRenderFns } from "./popoverPropertyRow.vue?vue&type=template&id=2c5e0c31&scoped=true&"
import script from "./popoverPropertyRow.vue?vue&type=script&lang=js&"
export * from "./popoverPropertyRow.vue?vue&type=script&lang=js&"
import style0 from "./popoverPropertyRow.vue?vue&type=style&index=0&id=2c5e0c31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e0c31",
  null
  
)

export default component.exports